<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="careRemind">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人余额统计
        </div>
        <div style="padding: 20px;">
            <el-card shadow="never">
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search">
                    <template slot="monthrange">
                        <el-date-picker
                            v-model="searchForm.month"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择月份">
                        </el-date-picker>
                    </template>
                    <template slot="rightButton">
                         <el-button type="success" icon="el-icon-download" @click="download">导出</el-button>
                    </template>
                </Search>
                <el-divider></el-divider>
                <el-row :gutter="20" v-if="sumData">
                    <el-col :span="6">
                        <div class="balanceStyle xian">
                            <div>
                                <div class="topMoney"><span style="font-size:18px">￥</span>{{sumData.sumBalance}}</div>
                                <div class="botName">余额总数</div>
                            </div>
                        </div>                        
                    </el-col>
                    <el-col :span="6">
                        <div  class="balanceStyle xian">
                             <div>
                                <div class="topMoney"><span style="font-size:18px">￥</span>{{sumData.sumDeposit}}</div>
                                <div class="botName">预交金总数</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div  class="balanceStyle xian">
                             <div>
                                <div class="topMoney"><span style="font-size:18px">￥</span>{{sumData.sumImprest}}</div>
                                <div class="botName">备用金总数</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div  class="balanceStyle">
                             <div>
                                <div class="topMoney" style="color:red"><span style="font-size:18px">￥</span>{{sumData.sumArrearage}}</div>
                                <div class="botName">欠款总数</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
            <div style="height: 10px;"></div>
            <div>
                <template>

                    <el-table v-loading="tableload" :data="tableData" :height="th" border style="width: 100%;" >
                        <el-table-column prop="name" label="老人姓名" min-width="100"></el-table-column>
                        <el-table-column prop="idCard" label="身份证号" min-width="100"></el-table-column>
                        <el-table-column prop="balance" label="余额"  min-width="100"></el-table-column>
                        <el-table-column prop="deposit" label="预交金"  min-width="80"></el-table-column>
                        <el-table-column prop="imprest" label="备用金"  min-width="80"></el-table-column>
                        <el-table-column prop="checkInStatus" label="是否在住"  min-width="180">
                            <template slot-scope="scope">
                                <el-tag v-show="scope.row.checkInStatus==1">是</el-tag>
                                <el-tag type="success" v-show="scope.row.checkInStatus==0">否</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";
    import Search from "@/components/Search";

    export default {
        name: "Role",
        data(){
            return{
                tableload:false,
                dialogFeeChange:false,
                dialogHandChange:false,
                selectInfo:'',
                tableData:null,
                sumData:null,
                totalItems: 0,
                pageSize:20,
                roomCodeList:[],
                feeTable:[],
                handTable:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                status:-1,
                th:0,searchData:[],
                searchForm:{
                    name: '',
                    idCard: ''
                },
                options:[]
            }
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight-160;
        },
        components: {
            Search
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val-160;
            },
        },
        methods:{
            init:function(){
                this.searchData=[
                    {span:12,name:'姓名',value:'name',type:'input'},
                    {span:12,name:'身份证号',value:'idCard',type:'input'},
                ]
                var nowDate=new Date();
                var dateMonth=new Date(nowDate.getFullYear(),nowDate.getMonth(),0);
                this.searchForm.month=timefilters(dateMonth).slice(0,7)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Statistics/ElderlyBalance",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    // this.tableload = false;
                    if(response.data.error == 0){
                        this.sumData = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            download(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                }
                Object.assign(data,this.searchForm)
                this.$axios.get(this.$institutionUrl + 'Elderly/ExportElBalanceRecord', {
                responseType: 'blob',
                params:data
                }).then(
                    (response) => {
                    loading.close();
                    // this.goodsClassDataShow = !this.goodsClassDataShow;
                    if (response.data.type === 'application/json') {
                        this.$message({type: 'info', message: '暂无数据'});
                    } else {
                        let fileName = '老人余额统计表.xlsx';
                        this.file(response, fileName);
                    }

                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableload=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetElderlyCheckinList",
                    data: data
                }).then( (response)=> {
                    this.tableload = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    _this.tableload = false;
                    console.log(error);
                });
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
          
        }
    }
</script>

<style lang="scss" scoped>
    // .BerthPage{
    //     .el-button{
    //         transform: translate(-1px,0);
    //     }
    // }
    .careRemind /deep/ .el-table__body tr.current-row>td {
        background: rgb(102, 177, 255);
        color:#fff;
    }
    .balanceStyle{
        width: 100%;
        display: flex;
        justify-content: center;
        .topMoney{
            font-size: 35px;
            font-weight: bold;
        }
        .botName{
            color: #999;
            text-align: center;
        }
    }
    .xian{
        border-right:1px solid #DCDFE6;
    }
</style>
